<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey">
        <template #header>
            <inertia-link :href="route('kiosk.users.index')">
                <AtomicButton color="yellow" class="mt-[27px]" size="sm">
                    {{ t("vue.back_to_all_users") }}
                    <template #icon>
                        <BackspaceIcon
                            class="mr-2 h-6 w-6 transition duration-200 group-hover:text-gray-600"
                        />
                    </template>
                </AtomicButton>
            </inertia-link>

            <UserTabsProfile
                :selected-user="selectedUser"
                :personal-team="personalTeam"
            />
        </template>
        <slot />
    </BasicTabs>
</template>

<script lang="ts" setup>
import {
    BackspaceIcon,
    UserGroupIcon,
    AdjustmentsVerticalIcon,
    ShieldExclamationIcon,
    GlobeAltIcon,
} from "@heroicons/vue/24/solid";

import { MegaphoneIcon } from "@heroicons/vue/24/outline";

import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import type IUser from "@/types/Members/IUser";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import type { PropType } from "vue";
import { useTranslations } from "@/composables/useTranslations";

const props = defineProps({
    tabKey: {
        type: String,
        default: "user-activity",
    },
    selectedUser: {
        type: Object as PropType<IUser>,
        required: true,
    },
    personalTeam: {
        type: Object as PropType<ICurrentTeam>,
        required: true,
    },
});

// Get access to translations
const { t } = useTranslations();

const tabs: TabItem[] = [
    {
        title: t("vue.teams_accounts"),
        key: "user-teams",
        icon: UserGroupIcon,
        url: route("kiosk.users.teams.index", {
            user: props.selectedUser.id,
        }),
    },
    {
        title: t("vue.features"),
        key: "feature-management",
        icon: AdjustmentsVerticalIcon,
        url: route("kiosk.users.feature-management.index", {
            user: props.selectedUser.id,
        }),
    },
    {
        title: t("vue.notifications"),
        key: "user-notifications",
        icon: MegaphoneIcon,
        url: route("kiosk.users.notifications.index", {
            user: props.selectedUser.id,
        }),
    },
    {
        title: t("vue.blocked_actions"),
        key: "user-blocked-actions",
        icon: ShieldExclamationIcon,
        url: route("kiosk.users.blocked-actions.index", {
            user: props.selectedUser.id,
        }),
    },
];
</script>
